//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

(function () {
  const curalate = angular.module('curalate');
  const statNames = {
    COMMENTS: 'comments',
    ENGAGEMENT_RATE: 'engagementRate',
    FOLLOWERS: 'followers',
    FOLLOWER_ENGAGEMENT_RATE: 'followerEngagementRate',
    INTERACTIONS: 'interactions',
    LIKES: 'likes',
    NOTES: 'notes',
    POSTS: 'posts',
    REACH: 'reach',
    REACH_ENGAGEMENT_RATE: 'reachEngagementRate',
    REPINS: 'repins',
    RETWEETS: 'retweets',
  };

  const statIcons = {
    [statNames.COMMENTS]: 'comments',
    [statNames.ENGAGEMENT_RATE]: 'multiple-users',
    [statNames.FOLLOWER_ENGAGEMENT_RATE]: 'multiple-users',
    [statNames.LIKES]: 'likes',
    [statNames.REACH]: 'reach',
    [statNames.REACH_ENGAGEMENT_RATE]: 'bar-graph',
    [statNames.REPINS]: 'pinterest',
    [statNames.RETWEETS]: 'twitter',
  };

  const statTooltips = {
    [statNames.COMMENTS]: 'Comments: Number of comments this post received.',
    [statNames.ENGAGEMENT_RATE]: `Follower Engagement Rate: The number of likes plus the number of
       comments divided by the number of current followers.`,
    [statNames.FOLLOWER_ENGAGEMENT_RATE]: `Follower Engagement Rate: The number of likes plus the number of
       comments divided by the number of current followers.`,
    [statNames.LIKES]: 'Likes: Number of times this post was liked.',
    [statNames.NOTES]: 'Notes: The number of notes this post received.',
    [statNames.REACH]:
      'Reach: The number of unique users who have seen this media.',
    [statNames.REACH_ENGAGEMENT_RATE]: `Engagement Rate: The number of likes plus the number of comments divided
       by the number of unique users who have seen this media.`,
    [statNames.REPINS]: 'Repins: The number of saves this post received.',
    [statNames.RETWEETS]: 'Reposts: The number of reposts this post received.',
  };

  curalate.constant('ContentCardViews', {
    GRID: 'grid',
    META: 'meta',
  });

  curalate.factory('ContentCardHelper', [
    '$filter',
    function ($filter) {
      const toItemStat = function (name, value) {
        if (value === undefined || _(value).isNaN()) {
          return undefined;
        }
        switch (name) {
          case statNames.LIKES: {
            return {
              name,
              value: $filter('readableNumber')(value),
              tooltip: statTooltips[name],
              icon: statIcons[name],
            };
          }
          case statNames.COMMENTS: {
            return {
              name,
              value: $filter('readableNumber')(value),
              tooltip: statTooltips[name],
              icon: statIcons[name],
            };
          }
          case statNames.FOLLOWER_ENGAGEMENT_RATE: {
            return {
              name,
              value: $filter('readablePercent')(value, true),
              tooltip: statTooltips[name],
              icon: statIcons[name],
            };
          }
          case statNames.REACH_ENGAGEMENT_RATE: {
            return {
              name,
              value: $filter('readablePercent')(value, true),
              tooltip: statTooltips[name],
              icon: statIcons[name],
            };
          }
          case statNames.REACH: {
            return {
              name,
              value: $filter('readableNumber')(value),
              tooltip: statTooltips[name],
              icon: statIcons[name],
            };
          }
          case statNames.NOTES: {
            return {
              name,
              value: $filter('readableNumber')(value),
              tooltip: statTooltips[name],
              // TODO: There is no tumblr icon in our codebase. Do we need to drop
              // one in here or can we cut this case?
            };
          }
          case statNames.REPINS: {
            return {
              name,
              value: $filter('readableNumber')(value),
              tooltip: statTooltips[name],
              icon: statIcons[name],
            };
          }
          case statNames.RETWEETS: {
            return {
              name,
              value: $filter('readableNumber')(value),
              tooltip: statTooltips[name],
              icon: statIcons[name],
            };
          }
          default: {
            return null;
          }
        }
      };

      const buildItemStats = function (stats) {
        return _([
          toItemStat(statNames.LIKES, stats.likes),
          toItemStat(statNames.COMMENTS, stats.comments),
          toItemStat(statNames.FOLLOWER_ENGAGEMENT_RATE, stats.engagementRate),
          toItemStat(
            statNames.FOLLOWER_ENGAGEMENT_RATE,
            stats.followerEngagementRate,
          ),
          toItemStat(
            statNames.REACH_ENGAGEMENT_RATE,
            stats.reachEngagementRate,
          ),
          toItemStat(statNames.REACH, stats.reach),
          toItemStat(statNames.REPINS, stats.repins),
          toItemStat(statNames.RETWEETS, stats.retweets),
          toItemStat(statNames.NOTES, stats.notes),
        ]).filter((stat) => {
          return stat !== undefined;
        });
      };

      return {
        buildItemStats,
      };
    },
  ]);
})();
